import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Classes from "./index.module.css";
// import Certificate from "../Certificate";
import content from "../../includes/content";
// import CertAnimation from "../certAnimation";
import { currencyFormatter, getAssetURL } from "../../utils";
import { Section, TitleBox, Title, TextBox, Text } from "./styles";
import ShareBox from "../ShareBox";

const PageFour = ({
  publicToggle,
  setPublicToggle,
  makePublic,
  loan,
  captureRef,
  handleCapture,
  handleCanvasDataURL,
  makeDefaultPrivate,
  setCustomURL,
  setSaveCustom,
  setTempURL,
  tempURL,
  customURL,
  initialURL,
  makePrivate,
  urlTernary,
  pageFive,
}) => {
  const load = useState(false);

  return (
    <Container className="main fadeIn">
      <Row>
        <Col className="text-space order-2 order-lg-1 d-flex flex-column justify-content-start align-items-center">
          <div
            className={`d-flex justify-content-center ${process.env.REACT_APP_CERTIFICATE_NAME}-logo-box`}
          >
            <Image
              className={`px-5 ${content.pageFourLogoClassName}`}
              title={content.pageFourLogoTitle}
              src={content.pageFourLogo}
              fluid
            />
          </div>
          <p className="awarded">
            I am proud to announce my financial success has been reviewed by Sun
            West, a major national lender, and I have been awarded a certificate
            for{" "}
            <span className="cert-name">
              {currencyFormatter(loan?.purchasePrice).split(".").shift()}
            </span>
            . With this, I can buy a{" "}
            <span className="cert-name">
              {currencyFormatter(loan?.purchasePrice).split(".").shift()}
            </span>{" "}
            house with the same strength as a cash buyer.
            <br />{" "}
            <a
              href={content.pageFourTermsLink}
              className="terms-conditions-disclaimer"
              title={content.pageFourTermsLinkTitle}
              target="_blank"
              rel="noreferrer"
            >
              (click here for terms & conditions)
            </a>
          </p>

          <div className="d-flex flex-column justify-content-center align-items-center mb-3">
            <p className="m-0 p-0 ">Your Certificate is Private</p>
            <button className="light-button " type="button">
              <div style={{ margin: "0 3px" }}>
                {pageFive
                  ? "Your certificate is publicly viewable"
                  : "Click Here to Make it Publicly Viewable"}
              </div>

              <input
                type="checkbox"
                checked={publicToggle}
                className="toggle-public"
                name="checkPublic"
                onChange={(e) => {
                  const check = e.target.checked;
                  setPublicToggle(check);
                  if (check) {
                    makePublic();
                  } else {
                    setTempURL(initialURL);
                    makePrivate();
                    setCustomURL(initialURL);
                  }
                }}
              />
            </button>
          </div>

          {pageFive && (
            <div className="fadeIn">
              <ShareBox
                makeDefaultPrivate={makeDefaultPrivate}
                setCustomURL={setCustomURL}
                setSaveCustom={setSaveCustom}
                setTempURL={setTempURL}
                tempURL={tempURL}
                customURL={customURL}
                loan={loan}
                urlTernary={urlTernary}
              />
            </div>
          )}

          {!pageFive ? (
            <div className="table-div d-flex flex-column justify-content-start align-items-center">
              <table>
                <tbody>
                  <tr>
                    <td>Purchase Price</td>
                    <td>{currencyFormatter(parseInt(loan?.purchasePrice))}</td>
                    {/* <td>{currencyFormatter(parseInt(1000))}</td> */}
                  </tr>
                  <tr>
                    <td>Loan Amount</td>
                    <td>{currencyFormatter(parseInt(loan?.loanAmount))}</td>
                    {/* <td>{currencyFormatter(parseInt(1000))}</td> */}
                  </tr>
                  <tr>
                    <td>Loan Program</td>
                    <td>{loan?.productDescription || loan?.productCodeDesc}</td>
                    {/* <td>fha:loan thingy</td> */}
                  </tr>
                  <tr>
                    <td>Down Payment</td>
                    <td>
                      {currencyFormatter(
                        parseInt(loan?.purchasePrice) -
                          parseInt(loan?.loanAmount)
                      )}
                    </td>
                    {/* <td>
                      {currencyFormatter(parseInt(10000) - parseInt(1000))}
                    </td> */}
                  </tr>
                  {content.pageFourShowDateCol && (
                    <tr>
                      <td>Approval Date</td>
                      <td>{loan?.truApprovalDateAsString}</td>
                    </tr>
                  )}
                  {content.pageFourShowDateCol && loan.creditExpireDate && (
                    <tr>
                      <td>Expiration Date</td>
                      <td>
                        {new Date(loan?.creditExpireDate).toLocaleDateString(
                          "en-US",
                          { year: "numeric", month: "numeric", day: "numeric" }
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {load[0] && captureRef.current.style ? (
                <div className="d-flex justify-content-center align-items-center DL-icon">
                  <Image
                    title="Click to Download Certificate!"
                    onClick={handleCapture}
                    fluid
                    src={getAssetURL("dl-icon.png")}
                  />
                  <p onClick={handleCapture} style={{cursor: "pointer"}}>
                    Click Here to download your
                    <br />
                    Financial Soundness Status Certificate
                  </p>
                </div>
              ) : (
                <></>
              )}
            </div>
          ) : (
            ""
          )}
        </Col>
      </Row>
      <Row>
        <Col className="text-space text-center">
          <h3 className="avoid-text">
            Avoid These Red Flags To Maintain your{" "}
            <span>{`${content.productName}`}</span>
          </h3>
          <div className="position-relative d-flex justify-content-end align-items-start tru-guidance">
            {/* <Image
              className="static-image"
              fluid
              src={getAssetURL("tru-guidance.png")}
            /> */}
            <Image
              className="dynamic-image"
              fluid
              src={getAssetURL("tru-guidance-blank.png")}
            />
            <div className="guidance-text">Missing Payments</div>
            <div className="guidance-text">Job Switch</div>
            <div className="guidance-text">Large Purchases</div>
            <div style={{ width: "fit-content" }} className="guidance-text">
              <div className="text-center w-100">Changing</div>
              <div className="text-center w-100">Bank Accounts</div>
            </div>
            <div className="guidance-text">Co-signing a Loan</div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Section>
            <TitleBox>
              <Title>
                <p className={Classes.doanddontheadline}>
                  {`In order to maintain your ${content.productName} please
                  comply with the following "DOs and DON'Ts"`}
                </p>
                <Row>
                  <Col xs={1} sm={1} md={2} xl={2} lg={2}></Col>
                  <Col xs={4} sm={4} md={4} xl={4} lg={4}>
                    <div className={Classes.dothumbcontainer}>
                      <div className={Classes.thumb_container}>
                        <img
                          src="https://resources.swmc.com/swmc-images/trueterms/upthumb-icon.svg"
                          alt="icon"
                          className={Classes.thumb_icon}
                        />
                      </div>
                      <div>
                        <p className={Classes.dothumbtext}>DO</p>
                      </div>
                    </div>
                  </Col>
                  <Col xs={2} sm={2} md={2} xl={2} lg={2}></Col>
                  <Col xs={4} sm={4} md={4} xl={4} lg={4}>
                    <div className={Classes.dontthumbcontainer}>
                      <div className={Classes.thumb_container}>
                        <img
                          src="https://resources.swmc.com/swmc-images/trueterms/downthumb-icon.svg"
                          alt="icon"
                          className={Classes.thumb_icon_2}
                        />
                      </div>
                      <div>
                        <p className={Classes.dontthumbtext}>DON'T</p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Title>
            </TitleBox>
            <TextBox pad="2vw 8.5vw 0.5vw 8.5vw">
              <Text>
                <div>
                  <Container>
                    <Row>
                      <Col xs={5} sm={5} md={5} xl={5} lg={5}>
                        <ol className={Classes.ksIxFF}>
                          <li className={Classes.lejapX}>
                            Maintain your current employment status, including
                            consistent work hours.
                          </li>
                          <li className={Classes.lejapX}>
                            Stay connected with us through{" "}
                            <a
                              href="https://www.swmc.com/angelai"
                              target="_blank"
                              rel="noreferrer"
                            >
                              AngelAi
                            </a>{" "}
                            and timely respond to messages we send to you
                            through{" "}
                            <a
                              href="https://www.swmc.com/angelai"
                              target="_blank"
                              rel="noreferrer"
                            >
                              AngelAi
                            </a>
                            , text, or e-mail messages.
                          </li>
                          <li className={Classes.lejapX}>
                            Upload onto{" "}
                            <a
                              href="https://www.swmc.com/angelai"
                              target="_blank"
                              rel="noreferrer"
                            >
                              AngelAi
                            </a>{" "}
                            recent pay stubs, asset and account statements, and
                            other documents we request.
                          </li>
                        </ol>
                      </Col>

                      <Col xs={1} sm={1} md={1} xl={1} lg={1}>
                        <img
                          src="https://resources.swmc.com/swmc-images/trueterms/line.svg"
                          alt="divider"
                          className={Classes.verticaldivider}
                        />
                      </Col>
                      <Col xs={5} sm={5} md={5} xl={5} lg={5}>
                        <ol className={Classes.ksIxFF}>
                          <li className={Classes.lejapX}>
                            Do anything that could adversely affect your credit
                            score (such as late payments on bills or debts).
                          </li>
                          <li className={Classes.lejapX}>
                            Take on new debt or open new charge accounts.
                          </li>
                          <li className={Classes.lejapX}>
                            Move cash from account to account without first
                            notifying us through{" "}
                            <a
                              href="https://www.swmc.com/angelai"
                              target="_blank"
                              rel="noreferrer"
                            >
                              AngelAi
                            </a>
                            .
                          </li>
                          <li className={Classes.lejapX}>
                            Open or close bank accounts.
                          </li>
                          <li className={Classes.lejapX}>
                            Accept gift funds from family without first
                            discussing it with us through{" "}
                            <a
                              href="https://www.swmc.com/angelai"
                              target="_blank"
                              rel="noreferrer"
                            >
                              AngelAi
                            </a>
                            .
                          </li>
                        </ol>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </Text>
            </TextBox>
          </Section>
        </Col>
      </Row>

      <div className="offscreen-cert">
        {content.certificateComponent(
          captureRef,
          loan,
          handleCanvasDataURL,
          load
        )}
      </div>
    </Container>
  );
};

export default PageFour;
